module.exports = __webpack_public_path__ + "img/load_room.64a7eacb.png";